import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import api from "../lib/api";
import { Spinner, EmptyState } from "../components/states";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/shop").then((r) => { setProducts(r.data); setLoading(false); }).catch(() => setLoading(false)); }, []);
  if (loading) return <Spinner />;
  return (
    <div className="mx-auto max-w-[1600px] px-4 sm:px-6 py-8">
      <div className="flex items-center gap-4 flex-wrap mb-4"><BackButton fallback="/" /><Breadcrumbs items={[{ label: "Live", to: "/" }, { label: "Shop" }]} /></div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">Shop</h1>
      <p className="mono-label text-[#71717A] mt-2">APPAREL · VINYL · ACCESSORIES</p>
      {products.length === 0 ? <EmptyState title="Shop is empty" /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {products.map((p, i) => (
            <div key={p.id} data-testid={`product-${p.id}`} className="card-copper rounded-xl overflow-hidden fade-up" style={{ animationDelay: `${i * 0.04}s` }}>
              <div className="aspect-square overflow-hidden bg-[#1A1A22]"><img src={p.image} alt={p.name} className="w-full h-full object-cover" /></div>
              <div className="p-4">
                <span className="mono-label text-[#71717A]">{p.category}</span>
                <p className="font-display font-semibold mt-1 truncate">{p.name}</p>
                <div className="flex items-center justify-between mt-3">
                  <div>
                    {p.discount_pct > 0 ? (
                      <><span data-testid={`member-price-${p.id}`} className="font-display font-bold text-[#E8552A]">₹{Number(p.member_price).toLocaleString("en-IN")}</span><span className="ml-2 text-xs text-[#71717A] line-through">{p.price}</span><span className="ml-2 mono-label text-[#10B981]">-{p.discount_pct}%</span></>
                    ) : <span className="font-display font-bold text-[#E8552A]">{p.price}</span>}
                  </div>
                  <button data-testid={`enquire-${p.id}`} onClick={() => { window.location.href = `mailto:harishmuthyala@outlook.com?subject=${encodeURIComponent("Rav3.Labs shop enquiry: " + p.name)}`; }} title="Enquire by email" className="copper-btn rounded-lg p-2"><ShoppingBag size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
